import React from 'react';
import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';
import { FaPhone } from "@react-icons/all-files/fa/FaPhone";

function GoogleMapComponent({ offices }) {
	const [selectedOffice, setSelectedOffice] = React.useState(null);

	const mapStyles = [
		{
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f5f5f5"
				}
			]
		},
		{
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#616161"
				}
			]
		},
		{
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"color": "#f5f5f5"
				}
			]
		},
		{
			"featureType": "administrative.land_parcel",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#bdbdbd"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#eeeeee"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#757575"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#e5e5e5"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#9e9e9e"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ffffff"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#757575"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#dadada"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#616161"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#9e9e9e"
				}
			]
		},
		{
			"featureType": "transit.line",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#e5e5e5"
				}
			]
		},
		{
			"featureType": "transit.station",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#eeeeee"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#c9c9c9"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#9e9e9e"
				}
			]
		}

	];

	return (
			<GoogleMap
				id="map"
				mapContainerStyle={{ width: '100%', height: '400px' }}
				zoom={4}
				center={{ lat: 36.497097456277125, lng: -4.956956720769978 }}
				options={{ styles: mapStyles }}
			>
				{offices.map((office, index) => (
					<Marker
						key={index}
						position={{ lat: office.lat, lng: office.lon }}
						onClick={() => {
							setSelectedOffice(office);
						}}
					/>
				))}

				{selectedOffice && (
					<InfoWindow
						position={{ lat: selectedOffice.lat, lng: selectedOffice.lon }}
						onCloseClick={() => {
							setSelectedOffice(null);
						}}
					>
						<div className="block md:flex">
							<div>
								<h5><strong>{selectedOffice.city}, {selectedOffice.country}</strong></h5>
								<h6 className='leading-7'>{selectedOffice.address}</h6>
								<h6 className="flex"><FaPhone className="mr-2" /> <a href={`tel:${selectedOffice.phone}`}>{selectedOffice.phone}</a></h6>
							</div>
							<img src={selectedOffice.image} style={{ height: '100%', objectFit: 'cover', marginLeft: '10px' }} alt="Holborn Office Locations Map" />
						</div>
					</InfoWindow>
				)}
			</GoogleMap>
	);
}

export default GoogleMapComponent;